<template>
  <div>
    <div class="bi-layout bi-campagne--global-infos">
      <!-- <vs-alert
      color="danger"
      title="Kampagne nicht gefunden"
      :active.sync="fetchFailed"
    >
      <span>Kampagne mit ID: {{ $route.params.id }} nicht gefunden.</span>
      <span>
        <span> Gehe zu </span
        ><router-link
          :to="{ name: 'bi.campaigns' }"
          class="text-inherit underline"
          >Alle Kampagnen</router-link
        >
      </span>
    </vs-alert> -->
      <div v-if="adCampaign" class="campaign-detail">
        <div class="vx-row">
          <div class="vx-col w-full xl:w-7/12">
            <h1>
              {{ adCampaign.number }} - {{ adCampaign.name }}
              <span class="cursor-pointer" @click="showEdit = !showEdit"
                ><i class="far fa-pen"></i
              ></span>
            </h1>
          </div>
          <div class="vx-col w-full xl:w-5/12">
            <div class="campaign-detail--infos">
              <ul style="text-align: right">
                <li v-if="adCampaign.userGroup" class="location">
                  <i class="fas fa-map-marker-alt"></i>
                  {{ adCampaign.userGroup.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div v-if="adCampaign.vacancies.length" class="vx-col w-full lg:mb-4">
            <div class="vacancy-toggle" @click="openVacancys = !openVacancys">
              <template v-if="!openVacancys">
                Alle Stellen zu deiner Kampagne anzeigen
                <i class="fas fa-plus"></i
              ></template>
              <template v-else>
                Stellen ausblenden <i class="fas fa-minus"></i>
              </template>
            </div>
          </div>
          <div
            v-if="adCampaign.vacancies.length && openVacancys"
            class="vx-col w-full"
          >
            <h4 class="lg:px-2">Zugeordnete Stellen</h4>
            <div class="vx-row campaign-detail--vacancies lg:mb-4 lg:px-2">
              <div
                v-for="vacancy of adCampaign.vacancies"
                :key="vacancy.id"
                class="vx-col w-full xl:w-1/2 lg:mb-2"
              >
                <div class="vx-row">
                  <div class="vx-col">
                    <template v-if="vacancy.active">
                      <span class="circul green"></span>
                    </template>
                    <template v-else>
                      <span class="circul red"></span
                    ></template>
                  </div>
                  <div class="vx-col w-full lg:w-6/12">
                    <router-link
                      :to="{
                        name: 'project.edit.sub.job',
                        params: {
                          page: 'jobs',
                          jobid: vacancy.id,
                          id: vacancy.project.id
                        }
                      }"
                    >
                      {{ vacancy.number }}
                      -
                      {{ vacancy.title }}
                    </router-link>
                  </div>
                  <div class="vx-col w-full lg:w-2/12">
                    {{ $d(new Date(vacancy.activeFrom), "short") }}
                  </div>
                  <div class="vx-col w-full lg:w-2/12">
                    {{ $d(new Date(vacancy.activeUntil), "short") }}
                  </div>
                  <div class="vx-col">
                    <template v-if="vacancy.vamExport">
                      <template
                        v-if="
                          (vacancy.vamSynced && !vacancy.vamExportError) ||
                            (vacancy.vamExport && !vacancy.vamExportError)
                        "
                      >
                        <img
                          src="@/assets/images/logo/ba_live.svg"
                          class="export-icon"
                          title="BA Export Erfolgreich"
                        />
                      </template>
                      <template
                        v-else-if="
                          vacancy.vamExport &&
                            vacancy.vamSynced &&
                            vacancy.vamExportError
                        "
                      >
                        <img
                          src="@/assets/images/logo/ba_warning.svg"
                          class="export-icon"
                          title="BA Export Fehlerhaft"
                        />
                      </template>
                    </template>
                    <template
                      v-if="
                        vacancy.allowOnlineApplication &&
                          expiredCheck(vacancy.activeUntil) == false
                      "
                    >
                      <img
                        src="@/assets/images/logo/logo-small.png"
                        class="export-icon"
                        :title="
                          'Stellenmarkt von ' +
                            formatDateFrom(vacancy.activeFrom) +
                            ' bis ' +
                            formatDateTo(vacancy.activeUntil)
                        "
                      />
                    </template>
                    <template
                      v-if="
                        vacancy.allowOnlineApplication &&
                          expiredCheck(vacancy.activeUntil) == true
                      "
                    >
                      <img
                        src="@/assets/images/logo/web_warning.svg"
                        class="export-icon"
                        title="Stellenmarkt Datum überschritten"
                      />
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <comparison-time-frame-input
              v-model="cardsTime"
              class="mb-4"
            ></comparison-time-frame-input>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col w-full xl:w-1/4 mb-6">
                <BiStatisticsCard
                  :id="adCampaign.id"
                  icon="fa-eye"
                  data="impressions"
                  title="Impressionen"
                  small
                  :type="statisticsType"
                  :limit-days="cardsTime.timeframe.from"
                  :limit-stop="cardsTime.timeframe.to"
                  :compare-start="cardsTime.compareTo.from"
                  :compare-stop="cardsTime.compareTo.to"
                />
              </div>
              <div class="vx-col w-full xl:w-1/4 mb-6">
                <BiStatisticsCard
                  :id="adCampaign.id"
                  icon="fa-euro-sign"
                  data="cost"
                  title="Ausgegebener Betrag"
                  small
                  :type="statisticsType"
                  :limit-days="cardsTime.timeframe.from"
                  :limit-stop="cardsTime.timeframe.to"
                  :compare-start="cardsTime.compareTo.from"
                  :compare-stop="cardsTime.compareTo.to"
                />
              </div>
              <div class="vx-col w-full xl:w-1/4 mb-6">
                <BiStatisticsCard
                  :id="adCampaign.id"
                  icon="fa-mouse"
                  data="clicks"
                  title="Klicks"
                  small
                  :type="statisticsType"
                  :limit-days="cardsTime.timeframe.from"
                  :limit-stop="cardsTime.timeframe.to"
                  :compare-start="cardsTime.compareTo.from"
                  :compare-stop="cardsTime.compareTo.to"
                />
              </div>
              <div class="vx-col w-full xl:w-1/4 mb-6">
                <BiStatisticsCard
                  :id="adCampaign.id"
                  icon="fa-euro-sign"
                  data="cpc"
                  title="CPC"
                  small
                  :type="statisticsType"
                  :limit-days="cardsTime.timeframe.from"
                  :limit-stop="cardsTime.timeframe.to"
                  :compare-start="cardsTime.compareTo.from"
                  :compare-stop="cardsTime.compareTo.to"
                />
              </div>
              <div class="vx-col w-full xl:w-1/4 mb-6">
                <BiStatisticsCard
                  :id="adCampaign.id"
                  icon="fa-euro-sign"
                  data="ctr"
                  title="CTR"
                  small
                  :type="statisticsType"
                  :limit-days="cardsTime.timeframe.from"
                  :limit-stop="cardsTime.timeframe.to"
                  :compare-start="cardsTime.compareTo.from"
                  :compare-stop="cardsTime.compareTo.to"
                />
              </div>
              <div class="vx-col w-full xl:w-1/4 mb-6">
                <BiStatisticsCard
                  :id="adCampaign.id"
                  icon="fa-briefcase"
                  data="applications"
                  title="Bewerbungen"
                  small
                  :type="statisticsType"
                  :limit-days="cardsTime.timeframe.from"
                  :limit-stop="cardsTime.timeframe.to"
                  :compare-start="cardsTime.compareTo.from"
                  :compare-stop="cardsTime.compareTo.to"
                />
              </div>
              <div class="vx-col w-full xl:w-1/4 mb-6">
                <BiStatisticsCard
                  :id="adCampaign.id"
                  icon="fa-briefcase"
                  data="costPerApplication"
                  title="Kosten pro Bewerbung"
                  small
                  :type="statisticsType"
                  :limit-days="cardsTime.timeframe.from"
                  :limit-stop="cardsTime.timeframe.to"
                  :compare-start="cardsTime.compareTo.from"
                  :compare-stop="cardsTime.compareTo.to"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="adCampaign && !showEdit"
      class="bi-layout bi-campagne--global-campagnes"
    >
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <h2 class="mb-0">Alle Kampagnen</h2>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-tabs>
            <vs-tab label="Alle" @click="statisticsType = 'ALL'">
              <div class="vx-row">
                <div class="vx-col w-full lg:w-1/2">
                  <h3 class="mb-3">Werbeanzeigen</h3>
                  <ad-stats
                    :google-ids="
                      adCampaign.googleAds
                        ? adCampaign.googleAds.map(ad => ad.adID)
                        : []
                    "
                    :facebook-ad-ids="
                      adCampaign.facebookAdInsights
                        ? adCampaign.facebookAdInsights.map(ad => ad.adID)
                        : []
                    "
                  ></ad-stats>
                </div>
                <div class="vx-col w-full lg:w-1/2">
                  <h3 class="mb-3">Stellen</h3>
                  <vacancy-stats
                    :vacancies="
                      adCampaign.vacancies
                        ? adCampaign.vacancies.map(v => v.id)
                        : []
                    "
                  ></vacancy-stats>
                </div>
              </div>
            </vs-tab>
            <vs-tab
              v-if="adCampaign.vacancies.length"
              label="Stellen"
              @click="statisticsType = 'ALL'"
            >
              <Website
                v-model="adCampaign.vacancies"
                @applicantNumberSet="v => (totalApplicants = v)"
              />
            </vs-tab>
            <vs-tab
              v-if="adCampaign.facebookAdInsights.length"
              :label="'Facebook (' + adCampaign.facebookInsightsCount + ')'"
              @click="statisticsType = 'FACEBOOK'"
            >
              <FacebookAd
                :campaign-id="adCampaign.id"
                :vacancies="adCampaign.vacancies"
                @applicantNumberSet="v => (facebookApplicants = v)"
              />
            </vs-tab>
            <vs-tab
              v-if="adCampaign.googleAds.length"
              :label="'Google (' + adCampaign.googleAdsCount + ')'"
              @click="statisticsType = 'GOOGLE'"
            >
              <GoogleAd
                :campaign-id="adCampaign.id"
                :vacancies="adCampaign.vacancies"
                @applicantNumberSet="v => (googleApplicants = v)"
              />
            </vs-tab>
            <vs-tab
              v-if="adCampaign.cleverreachReports.length"
              :label="
                'Cleverreach (' + adCampaign.cleverreachReportsCount + ')'
              "
              @click="statisticsType = 'CLEVERREACH_REPORT'"
            >
              <Cleverreach :campaign-id="adCampaign.id" />
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
    </div>
    <div v-if="showEdit" class="bi-layout bi-campagne--global-campagnes">
      <div class="bi-campaign--info-box">
        <h3>Kampagne bearbeiten</h3>
        <ValidationObserver ref="campaignEdit" tag="form">
          <CampaignGeneralForm v-model="internalAdCampaign" />
          <div style="text-align: right">
            <vs-button class="mt-3" @click="save()">Speichern</vs-button>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import dataDefaults from "../../../../assets/utils/dataDefaults";
import moment from "moment";
import BiStatisticsCard from "@/components/bi/BiStatisticsCard.vue";
import FacebookAd from "./services/FacebookAd.vue";
import GoogleAd from "./services/GoogleAd.vue";
import Website from "./services/Website.vue";
import Cleverreach from "./services/Cleverreach.vue";
import CampaignGeneralForm from "../form/CampaignGeneral";
import editFormMixin from "@/mixins/editFormMixin.js";
import ComparisonTimeFrameInput from "../../../../components/bi/ComparisonTimeFrameInput.vue";
import AdStats from "./Charts/AdStats.vue";
import VacancyStats from "./Charts/vacancyStats.vue";

export default {
  components: {
    BiStatisticsCard,
    FacebookAd,
    GoogleAd,
    Website,
    Cleverreach,
    CampaignGeneralForm,
    ComparisonTimeFrameInput,
    AdStats,
    VacancyStats
  },
  mixins: [
    editFormMixin({
      dataProp: "internalAdCampaign",
      idFields: [
        "userGroup",
        "vacancies",
        "facebookAdInsights",
        "cleverreachReports",
        "googleAds"
      ],
      ignoredFields: [
        "number",
        "facebookInsightsCount",
        "cleverreachReportsCount",
        "googleAdsCount"
      ]
    })
  ],
  data() {
    return {
      saveInterval: null,
      showEdit: false,
      openVacancys: false,
      statisticsType: "ALL",
      googleApplicants: 0,
      facebookApplicants: 0,
      totalApplicants: 0,
      cardsTime: dataDefaults.timeFrameInput()
    };
  },
  apollo: {
    adCampaign: {
      query: gql`
        query adCampaign($id: ID!) {
          adCampaign(id: $id) {
            id
            name
            number
            budget
            googleAdsBudget
            facebookAdInsightBudget
            dateStart
            dateStop
            facebookInsightsCount
            cleverreachReportsCount
            googleAdsCount
            userGroup {
              id
              name
            }
            vacancies {
              id
              number
              title
              active
              vamExport
              vamSynced
              vamExportError
              allowOnlineApplication
              activeFrom
              activeUntil
              project {
                id
              }
            }
            facebookAdInsights {
              id
              adName
            }
            cleverreachReports {
              id
              name
            }
            googleAds {
              id
              adName
              adID
              adGroupName
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      result({ data }) {
        if (!data.adCampaign || !data.adCampaign.vacancies) {
          return;
        }

        if (data.adCampaign.vacancies.length) {
          this.statisticsType = "ALL";
        } else if (data.adCampaign.facebookInsightsCount) {
          this.statisticsType = "FACEBOOK";
        } else if (data.adCampaign.googleAdsCount) {
          this.statisticsType = "GOOGLE";
        } else if (data.adCampaign.cleverreachReportsCount) {
          this.statisticsType = "CLEVERREACH_REPORT";
        }
      }
    }
  },
  computed: {
    internalAdCampaign: {
      get() {
        return this.adCampaign;
      },
      set() {
        this.save(false);
      }
    },
    numberOfApplicants() {
      if (this.statisticsType === "FACEBOOK") {
        return this.facebookApplicants;
      } else if (this.statisticsType === "GOOGLE") {
        return this.googleApplicants;
      }
      return this.totalApplicants;
    }
  },
  watch: {
    internalAdCampaign: {
      deep: true,
      handler(v) {
        this.internalAdCampaign = v;
      }
    }
  },
  methods: {
    expiredCheck(until) {
      var today = new Date();
      if (moment(today).isBefore(until)) {
        return false;
      } else {
        return true;
      }
    },
    formatDateFrom(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    formatDateTo(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    dateMonth() {
      return moment().subtract(30, "days");
    },
    async persist() {
      if (!this.showEdit) {
        return;
      }
      let result = await this.$refs.campaignEdit.validate();
      if (result == true) {
        let input = this.getInput();

        await this.$apollo
          .mutate({
            mutation: gql`
              mutation($id: ID!, $input: AdCampaignInput!) {
                updateAdCampaign(id: $id, input: $input) {
                  id
                }
              }
            `,
            variables: {
              id: this.adCampaign.id,
              input
            }
          })
          .then(() => {
            this.$vs.notify({
              title: "Kampagne gespeichert",
              text: "Die Kampagne wurde erfolgreich gespeichert",
              color: "success",
              icon: "query_builder",
              position: "bottom-center"
            });

            this.reportSuccess(input);
          })
          .catch(error => {
            this.reportUnhandledError(error);
          });
      } else {
        this.$vs.notify({
          title: "Speichern fehlgeschlagen",
          text: "Bitte überprüfe ob alle Pflichtfelder eingetragen sind.",
          color: "danger",
          icon: "query_builder",
          position: "bottom-center",
          time: 5000
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/components/bi/main";
</style>
